import React, { Suspense, useEffect } from 'react';
import moment from 'moment';
import Clarity from '@microsoft/clarity';

import { QueryClientProvider } from '@tanstack/react-query';
import ContextBind from './contexts';
import Router from './routes';
import GlobalStyles from './styles/global';

import { PageContainer } from './components/Layout';

import 'antd/dist/reset.css';
import queryClient from './store/queryClient';
import { FlagsProvider } from './contexts/Flags';
import { ConfigProvider } from './components/Layout/ConfigProvider';
import env from './env';
//
moment.locale('pt-br');
//
const App: React.FC = () => {
    useEffect(() => {
        const clarityProjectId = import.meta.env.VITE_CLARITY_PROJECT_V2_ID;
        if (import.meta.env.PROD && clarityProjectId && env.IS_PRODUCTION_API) {
            Clarity.init(clarityProjectId);
        }
    }, []);
    return (
        <QueryClientProvider client={queryClient}>
            <ContextBind>
                <ConfigProvider>
                    <GlobalStyles />
                    <Suspense fallback={<div />}>
                        <PageContainer>
                            <FlagsProvider>
                                <Router />
                            </FlagsProvider>
                        </PageContainer>
                    </Suspense>
                </ConfigProvider>
            </ContextBind>
        </QueryClientProvider>
    );
};

export default App;
